import {Loader} from "@/components/placeholder/Loader.tsx";

import styles from "./StatusPageConsumption.module.scss";

// Full-page loading state shared by the consumption pages and the host-resolution
// wrappers, so the loading chrome stays consistent in one place.
export const ConsumptionPageLoader = () => (
  <div className={styles.pageWrapper}>
    <div className={styles.loadingContainer}>
      <Loader />
    </div>
  </div>
);
